import { z } from 'zod'

export const StepTypeSchema = z.enum(['SOURCE', 'VIEW', 'ACTION'])
export type StepType = z.infer<typeof StepTypeSchema>

export const FinalActionSchema = z.enum(['SAVE', 'FAVORITE'])
export type FinalAction = z.infer<typeof FinalActionSchema>

const chainBase = {
  chainId: z.string().min(1),
  sessionId: z.string().optional(),
  productId: z.union([z.number(), z.string()]).optional(),
  sourceImageUrl: z.string().url().optional(),
}

export const TrackActionChainRequestSchema = z
  .discriminatedUnion('stepType', [
    z.object({
      ...chainBase,
      stepType: z.literal('SOURCE'),
      sourceCategoryId: z.number().optional(),
      sourceCategoryCode: z.string().optional(),
      sourceCategoryName: z.string().optional(),
    }),
    z.object({
      ...chainBase,
      stepType: z.literal('VIEW'),
      viewProductId: z.union([z.number(), z.string()]).optional(),
      viewReferenceUrl: z.string().url().optional(),
      viewCategoryId: z.number().optional(),
      viewCategoryCode: z.string().optional(),
      viewCategoryName: z.string().optional(),
      viewIsOther: z.boolean().optional(),
    }),
    z.object({
      ...chainBase,
      stepType: z.literal('ACTION'),
      finalAction: FinalActionSchema,
      resultImageUrl: z.string().url().optional(),
    }),
  ])
  .superRefine((data, ctx) => {
    if (!data.productId && !data.sourceImageUrl) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'productId 或 sourceImageUrl 至少传一个',
        path: ['productId'],
      })
    }
    if (data.stepType === 'SOURCE') {
      if (!data.sourceCategoryCode && !data.sourceCategoryName && !data.sourceImageUrl) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'sourceCategoryCode 或 sourceCategoryName 至少传一个',
          path: ['sourceCategoryCode'],
        })
      }
    } else if (data.stepType === 'VIEW') {
      if (data.viewIsOther === true) {
        return
      }
      if (!data.viewProductId) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'viewProductId 必传（或 viewIsOther=true）',
          path: ['viewProductId'],
        })
      }
      if (!data.viewCategoryCode && !data.viewCategoryName) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'viewCategoryCode 或 viewCategoryName 至少传一个（或 viewIsOther=true）',
          path: ['viewCategoryCode'],
        })
      }
    }
  })

export type TrackActionChainRequest = z.infer<
  typeof TrackActionChainRequestSchema
>
